import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import withFilterOptions from "src/hoc/withFilterOptions";
import { fetchOptions } from "src/redux/slices/filter";
import OutlinedInput from "@mui/material/OutlinedInput";

export default function ASelect({
  value,
  options,
  handleSelect,
  placeholder,
  ...others
}) {
  return (
    <FormControl sx={{ m: 1, minWidth: 120 }}>
      <Select
        displayEmpty
        {...others}
        input={<OutlinedInput />}
        value={value}
        onChange={(event) => {
          handleSelect(event.target.value);
        }}
      >
        <MenuItem disabled value="">
          {placeholder}
        </MenuItem>
        {options.map((option, idx) => (
          <MenuItem key={idx} value={option.id}>
            {option.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

const ASelectWithOptions = withFilterOptions(ASelect, (by) =>
  fetchOptions({ by })
);

export { ASelectWithOptions };
